import type { SplitViewContentType } from '@saaga/shared/store/slices/split-view.slice'
import type { ReactNode } from 'react'

import { getContentDefinition } from './split-view.registry'
import { SplitViewInvalid } from './split-view-invalid.atom'
import { SplitViewNoContent } from './split-view-no-content.atom'
import { SplitViewUnknown } from './split-view-unknown.atom'
import { SplitViewValidContent } from './split-view-valid-content.atom'

export interface SplitViewContainerProps {
  contentType: SplitViewContentType
  contentData: Record<string, unknown> | null
  onClose: () => void
  isCloseButtonHidden?: boolean
  className?: string
}

export const SplitViewContainer: React.FC<SplitViewContainerProps> = ({
  contentType,
  contentData,
  onClose,
  isCloseButtonHidden = false,
  className,
}): ReactNode => {
  if (!contentType) {
    return (
      <SplitViewNoContent
        onClose={onClose}
        isCloseButtonHidden={isCloseButtonHidden}
        className={className}
      />
    )
  }

  const definition = getContentDefinition(contentType)

  if (!definition) {
    return (
      <SplitViewUnknown
        onClose={onClose}
        isCloseButtonHidden={isCloseButtonHidden}
        className={className}
      />
    )
  }

  if (!contentData || !definition.isValidData(contentData)) {
    return (
      <SplitViewInvalid
        definition={definition}
        onClose={onClose}
        isCloseButtonHidden={isCloseButtonHidden}
        className={className}
      />
    )
  }

  return (
    <SplitViewValidContent
      definition={definition}
      contentData={contentData}
      onClose={onClose}
      isCloseButtonHidden={isCloseButtonHidden}
      className={className}
    />
  )
}
